export const initialStateForFees = {
  uuid: '',
  name: '',
  admin_fee: '',
  rebate_fee: '',
  contracting_labor: '',
  marketplace_ar_vendor: '',
  marketplace_ar_health_system_split: ''
}
